export const GET_BEST_SALE_ACTION = "GET_BEST_SALE_ACTION";
export const SET_BEST_SALE_ACTION = "SET_BEST_SALE_ACTION";

export const GET_CRM_SHOP_INFO_ACTION = "GET_CRM_SHOP_INFO_ACTION";
export const GET_CRM_SHOP_INFO_SPLASH_ACTION =
	"GET_CRM_SHOP_INFO_SPLASH_ACTION";
export const SET_CRM_SHOP_INFO_ACTION = "SET_CRM_SHOP_INFO_ACTION";

export const GET_CRM_LEVEL_INFO_ACTION = "GET_CRM_LEVEL_INFO_ACTION";
export const SET_CRM_LEVEL_INFO_ACTION = "SET_CRM_LEVEL_INFO_ACTION";

export const GET_CRM_REWARD_DETAIL_ACTION = "GET_CRM_REWARD_DETAIL_ACTION";
export const SET_CRM_REWARD_DETAIL_ACTION = "SET_CRM_REWARD_DETAIL_ACTION";

export const SIGNATURE_REWARD_CONFIRM_ACTION =
	"SIGNATURE_REWARD_CONFIRM_ACTION";
